export default __webpack_public_path__ + "shareScreen.864dad64aef8db0693d882c77047525f.svg";